<template>
  <div>
    <h2>Books</h2>
      <book-item v-for="book in books" v-bind:key="book.id" v-bind:book="book">
      </book-item>
  </div>
</template>

<script>
  import BookItem from "./Book";
  import data from '../data';

  export default {
    name: "Books",
    components: {BookItem},
    data () {
      return {
        books: []
      }
    },
    mounted() {
      data.books(response => {
        this.books = response.json()['objects'];
      })
    }
  }
</script>

<style scoped>

</style>